<template>
  <v-toolbar
    :color="themeColor"
    flat>

    <v-text-field
      class="search-input"
      v-model="name"
      color="black"
      placeholder="搜尋"
      prepend-inner-icon="search"/>

    <v-btn
      @click.stop="$emit('toggleFilter')"
      flat
      icon>
      <v-icon>filter_list</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
export default {
  data() {
    return {};
  },

  computed: {
    name: {
      get() {
        return this.$store.state.teacher.filter.name;
      },
      set(value) {
        if (value === this.name) {
          return;
        }
        this.$store.commit('teacher/updateFilter', {name: value});
      }
    }
  }
};
</script>

